import useRankingTable from '../../../hooks/useRankingTable';
import { Table } from '../../Table';
import { Errors } from '../style';
import { StyledTables } from '../style';
import { TableComponentProps } from '../types';

const columnLables = {
  ranking: {
    name: 'Ranking (AIFM principal markets)'
  },
  // market_code_type: {
  // 	name: 'Market Type Code Description',
  // },
  market_code_type: {
    name: 'Code type of the principal market in which the AIFM trades'
  },
  market_code: {
    name: 'MIC code of the principal market in which the AIFM trades'
  },
  aggregated_value_amount: {
    name: 'Aggregated value of the principal market in which the AIFM trades'
  }
};

export function MostImportPortfolioAIF001({
  onChangeFund,
  funds,
  currentDataKey,
  schema,
  isStaticTemplate,
  isMultiFunds
}: TableComponentProps) {
  const {
    tables,
    columns: columns,
    onChange: onChange
  } = useRankingTable({
    data: funds[currentDataKey]?.fund_data?.AIFM_FIVE_PRINCIPAL_MARKET,
    onChangeFund,
    schema: schema.AIFM_FIVE_PRINCIPAL_MARKET,
    isStaticTemplate,
    requiredFields:
      funds[currentDataKey]?.required_tables?.AIFM_FIVE_PRINCIPAL_MARKET?.field_names || [],
    columnLables,
    order: 26,
    hasOrderNumber: false,
    tableName: 'AIFM_FIVE_PRINCIPAL_MARKET',
    isMultiFunds,
    funds
  });

  const isRequiredTable =
    funds[currentDataKey]?.required_tables?.AIFM_FIVE_PRINCIPAL_MARKET?.field_names?.length === 0;

  const errors = funds[currentDataKey]?.fund_data?.AIFM_FIVE_PRINCIPAL_MARKET?.find(
    item => item?.errors?.general
  )?.errors?.general;

  return (
    <>
      <Errors id="reporttables-most-important-portfolio-aif001-errors">
        {isRequiredTable && (
          <li id="reporttables-most-important-portfolio-aif001-required-error">
            This section must be completed
          </li>
        )}
        {errors?.map(item => (
          <li key={item.msg} id={`reporttables-most-important-portfolio-aif001-error-${item.msg}`}>
            {item.msg}
          </li>
        ))}
      </Errors>

      <StyledTables id="reporttables-most-important-portfolio-aif001-group">
        {tables.map((rows, index) => (
          <Table
            key={index + 'AIFM_FIVE_PRINCIPAL_MARKET'}
            id={`reporttables-most-important-portfolio-aif001-table-${index + 1}`}
            handleChanges={onChange}
            columns={columns}
            rows={rows}
            stickyLeftColumns={isMultiFunds && Object.keys(funds).length > 2 ? 2 : null}
          />
        ))}
      </StyledTables>
    </>
  );
}
